import { Directive } from '@angular/core';

@Directive({
    selector: '[ndtLeftColumn]',
    host: { class: 'left-column' },
    standalone: false
})
export class LeftColumnDirective {}
